import { render } from "./CalendarListItemLoadingPlaceholder.vue?vue&type=template&id=5c10f69c"
import script from "./CalendarListItemLoadingPlaceholder.vue?vue&type=script&lang=js"
export * from "./CalendarListItemLoadingPlaceholder.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__